import type { CSSProperties } from 'react';

export const RC_TREE_MOTION_NAME = 'xa-tree-node-motion';

const collapsedStyle = (): CSSProperties => ({ height: 0, opacity: 0 });

const expandActiveStyle = (node: HTMLElement): CSSProperties => ({
  height: node.scrollHeight,
  opacity: 1,
});

const leaveStartStyle = (node: HTMLElement): CSSProperties => ({
  height: node.offsetHeight,
  opacity: 1,
});

const collapseActiveStyle = (): CSSProperties => ({ height: 0, opacity: 0 });

export const RC_TREE_MOTION = {
  motionName: RC_TREE_MOTION_NAME,
  motionAppear: false,
  onAppearStart: collapsedStyle,
  onAppearActive: expandActiveStyle,
  onEnterStart: collapsedStyle,
  onEnterActive: expandActiveStyle,
  onLeaveStart: leaveStartStyle,
  onLeaveActive: collapseActiveStyle,
} as const;
